import { AHIcon, Box, Circle, TouchableBox } from "arkh";
import { StyleSheet, ViewStyle } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

type Props = {
  onRequestClose: () => void;
};

const ImageDefaultHeader = ({ onRequestClose }: Props) => {
  const safeAreaInsets = useSafeAreaInsets();
  return (
    <Box insets={{ top: safeAreaInsets.top }} style={styles.root}>
      <TouchableBox
        onPress={onRequestClose}
        spaceHorizontal="medium"
        spaceBottom="medium"
      >
        <Circle size="large" color="background">
          <AHIcon type="clear" size="medium" />
        </Circle>
      </TouchableBox>
    </Box>
  );
};

const styles = StyleSheet.create({
  root: {
    alignItems: "flex-end",
    pointerEvents: "box-none",
  },

  blurredBackground: {
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  } as ViewStyle,
});

export default ImageDefaultHeader;
